import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import { blue, grey, lightBlue, red } from "@material-ui/core/colors";
import { Select, MenuItem } from "@material-ui/core";

export const customStyles = makeStyles((theme) =>
  createStyles({
    h2PrimaryUpdateTitle: {
      fontSize: "large",
      color: theme.palette.primary.main + " !important"
    },
  })
);

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main + " !important",
    fontSize: "15px", 
    border: "1px solid " + theme.palette.secondary.main + " !important",
    borderRadius: "4px",      
    padding: "7px 10px",
  },
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
  whiteSpace: "break-spaces",
  },
  icon: {
    color: theme.palette.secondary.main + " !important",
  },
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "left !important",
    color: theme.palette.secondary.main + " !important",
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
    "&:focus": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
  },
}))(MenuItem);